<!-- Pagination -->
<nav aria-label="Page navigation" class="mt-2">
  <ul class="pagination d-flex flex-wrap justify-content-end pagination-sm">
    <!-- Change page size -->
    <li class="pagination-text w-100 text-center" *ngIf="paginate.totalRow == 0 && isShowNoRecord">
        {{'form.no_record' | translate}}
    </li>
    <li class="pagination-text mr-3" *ngIf="paginate.totalRow > 0 && isShowChangeRecordOfPage">
        {{'form.record' | translate}}
      </li>
    <li class="mr-3">
      <mat-form-field style="width: 42px" *ngIf="paginate.totalRow > 0 && isShowChangeRecordOfPage">
        <mat-select (focusout)="(checkFocus = true)" (focus)="commonService.openComboBox(checkFocus, pageSizeSelect)" id="pageSize" #pageSizeSelect
        name="pageSize" [(ngModel)]="paginate.pageSize" (selectionChange)="checkFocus = false; onChangeTotalRecord();">
          <mat-option [value]=10>10</mat-option>
          <mat-option [value]=20>20</mat-option>
          <mat-option [value]=50>50</mat-option>
          <mat-option [value]=100>100</mat-option>
          <mat-option [value]=200>200</mat-option>
        </mat-select>
      </mat-form-field>

    </li>
    <li class="pagination-text mr-3" *ngIf="paginate.totalRow > 0">
      {{'form.record_total' | translate}} <strong style="color: #000;">{{paginate.totalRow}}</strong>
    </li>
    <!-- Go to first page -->
    <li class="page-item" *ngIf="paginate.totalRow > 0">
      <button mat-icon-button color="primary" [matTooltip]="'form.record_first_page'| translate"
        [disabled]="paginate.currentPage == 0 || paginate.totalPage < 2"
        (click)="onPageChange($event, (paginate.currentPage == 0 ? 0 : 1))">
        <mat-icon>first_page</mat-icon>
      </button>
    </li>
    <!-- Go to previous page -->
    <li class="page-item" *ngIf="paginate.totalRow > 0">
      <button mat-icon-button color="primary" [matTooltip]="'form.record_previous_page'| translate"
        [disabled]="paginate.currentPage == 0 || paginate.totalPage < 2"
        (click)="onPageChange($event, paginate.currentPage)">
        <mat-icon>chevron_left</mat-icon>
      </button>
    </li>

    <!-- Page(s) render -->
    <ng-container *ngFor="let pageNo of paginate.totalPageArray">
      <li *ngIf="paginate.currentPage > 2 && pageNo == paginate.currentPage - 2" class="page-item">
        <button mat-icon-button disabled>
          <mat-icon>more_horiz</mat-icon>
        </button>
      </li>
      <li *ngIf="paginate.currentPage > 1 && pageNo == paginate.currentPage - 1" class="page-item">
        <button color="primary" mat-icon-button (click)="onPageChange($event, pageNo)">
          {{pageNo}}
        </button>
      </li>
      <li *ngIf="paginate.currentPage > 0 && pageNo == paginate.currentPage" class="page-item">
        <button color="primary" mat-icon-button (click)="onPageChange($event, pageNo)">
          {{pageNo}}
        </button>
      </li>
      <li *ngIf="paginate.currentPage == pageNo - 1" class="page-item">
        <button mat-icon-button *ngIf="paginate.currentPage != pageNo - 1" (click)="onPageChange($event, pageNo)">
          {{pageNo}}
        </button>
        <button mat-mini-fab color="primary" class="font-weight-bold" *ngIf="paginate.currentPage == pageNo - 1"
          (click)="onPageChange($event, pageNo)">
          {{pageNo}}
        </button>
      </li>
      <li *ngIf="paginate.currentPage < paginate.totalPage - 1 && pageNo == paginate.currentPage + 2" class="page-item">
        <button color="primary" mat-icon-button (click)="onPageChange($event, pageNo)">
          {{pageNo}}
        </button>
      </li>
      <li *ngIf="paginate.currentPage < paginate.totalPage - 2 && pageNo == paginate.currentPage + 3" class="page-item"
        (click)="onPageChange($event, pageNo)">
        <button color="primary" mat-icon-button (click)="onPageChange($event, pageNo)">
          {{pageNo}}
        </button>
      </li>
      <li *ngIf="paginate.currentPage < paginate.totalPage - 3 && pageNo == paginate.currentPage + 4" class="page-item">
        <button color="primary" mat-icon-button disabled>
          <mat-icon>more_horiz</mat-icon>
        </button>
      </li>
    </ng-container>

    <!-- Go to next page -->
    <li class="page-item" *ngIf="paginate.totalRow > 0">
      <button mat-icon-button color="primary" [matTooltip]="'form.record_next_page'| translate"
        [disabled]="paginate.currentPage == paginate.totalPage - 1 || paginate.totalPage < 2"
        (click)="onPageChange($event, paginate.currentPage + 2)">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </li>
    <!-- Go to last page -->
    <li class="page-item" *ngIf="paginate.totalRow > 0">
      <button mat-icon-button color="primary" [matTooltip]="'form.record_last_page'| translate"
        [disabled]="paginate.currentPage == paginate.totalPage - 1 || paginate.totalPage < 2"
        (click)="onPageChange($event, (paginate.currentPage == paginate.totalPage - 1 ? paginate.totalPage + 1 : paginate.totalPage))">
        <mat-icon>last_page</mat-icon>
      </button>
    </li>
  </ul>
</nav>
<!-- /Pagination -->
